import * as React from 'react';
import { useState } from 'react';

import TreeAPC from '..//TreeAPC/TreeAPC';
import { ITreeAPC_branch } from '..//TreeAPC/TreeAPC';
import '../../hmilib/hmiglobal';
import * as hmiclientbase from '../../hmilib/hmiclientbase';

import Button from '../../common/button/Button';
import { widget } from 'jquery';

interface IProps {
    closeCB?: () => void;
    saveCB?: (pathBlock: string, classBlock: string, nameFunc: string) => void;
}
interface IState {
    tree?: ITreeAPC_branch[];
    selectedData?: any;
    selectedNameFunc: string;
}

class WindowSettingRefMethod extends React.Component<IProps, IState> {
    //данные с сервера
    private propTree = new Map<string, any>();
    //типы данных по классам
    private classNameArr = new Map<string, any>();

    constructor(props: IProps) {
        super(props);
        this.state = {
            tree: [],
            selectedData: {},
            selectedNameFunc: ''
        };
        this.propTree = new Map<string, any>();
        this.classNameArr = new Map<string, any>();
    }

    public componentDidMount() {
        this.SetLoad();
    }

    private SetLoad() {
        if (window.GetConnectState()) {
            this.getConf();
        } else {
            setTimeout(() => {
                this.SetLoad();
            }, 1000);
        }
    }

    //обработка запросов на получение данных с сервера
    public getConf(branch?: ITreeAPC_branch, id?: string) {
        if (branch && id) {
            this.getData(id, 1).then((data) => {
                if (data.newData) {
                    let tempBranch = this.updateConf(data.data, this.classNameArr.get(data.data.ClassName));
                    branch.children = tempBranch.children;
                    this.setState({
                        tree: this.state.tree,
                        selectedData: data.data,
                        selectedNameFunc: ''
                    });
                } else {
                    this.setState({
                        selectedData: data.data,
                        selectedNameFunc: ''
                    });
                }
            });
        } else {
            this.getData(id, 1).then((data) => {
                this.genTree(data.data, this.classNameArr.get(data.data.ClassName));
            });
        }
    }
    private async getData(id?: string, diveToLevel?: number, curLevel?: number) {
        diveToLevel = diveToLevel === undefined ? 0 : diveToLevel;
        let Level = curLevel === undefined ? 0 : curLevel + 1;

        let newData = false;

        let promObj: any = await new Promise((res) => {
            if (!id) {
                hmiclientbase.SettingsGetObjectDto().then((data: any) => {
                    this.propTree.set(data.id, data);
                    newData = true;
                    res(data);
                });
            } else if (!this.propTree.has(id)) {
                //нет в загруженных data, запрашиваем
                hmiclientbase.SettingsGetObjectDto(id).then((data: any) => {
                    this.propTree.set(id, data);
                    newData = true;
                    res(data);
                });
            } else {
                res(this.propTree.get(id));
            }
        });

        let promObjClass: any = await new Promise((res) => {
            if (!this.classNameArr.has(promObj.ClassName)) {
                //нет в загруженных type, запрашиваем
                hmiclientbase.SettingsGetType(promObj.ClassName).then((type: any) => {
                    res(type[promObj.ClassName]);
                    this.classNameArr.set(promObj.ClassName, type[promObj.ClassName]);
                });
            } else {
                res(this.classNameArr.get(promObj.ClassName));
            }
        });
        if (diveToLevel > Level) {
            for (let key = 0; key < promObjClass.length; key++) {
                if (typeof promObj[promObjClass[key].Name] === 'object' && promObj[promObjClass[key].Name] !== null) {
                    if (promObjClass[key].ReturnTypes[0].indexOf('System.Collections.Generic.Dictionary') > -1) {
                        for (let dKey in promObj[promObjClass[key].Name]) {
                            if (promObj[promObjClass[key].Name][dKey].id !== undefined) {
                                let temp: any = await this.getData(
                                    promObj[promObjClass[key].Name][dKey].id,
                                    diveToLevel,
                                    Level
                                );
                                promObj[promObjClass[key].Name][dKey] = temp.data;
                                newData = temp.newData;
                            }
                        }
                    } else {
                        let temp: any = await this.getData(promObj[promObjClass[key].Name].id, diveToLevel, Level);
                        promObj[promObjClass[key].Name] = temp.data;
                        newData = temp.newData;
                    }
                }
            }
        }

        return { data: promObj, newData: newData };
    }

    private findType = (typeArr: any, key: string): any => {
        return typeArr.filter((elem: any) => {
            return elem.Name === key;
        })[0];
    };
    //
    private updateConf = (obj: any, type: any, parentBranch?: ITreeAPC_branch): any => {
        function isEmpty(obj: any) {
            for (let key in obj) {
                // если тело цикла начнет выполняться - значит в объекте есть свойства
                return false;
            }
            return true;
        }

        function findType(typeArr: any, key: string) {
            return typeArr.filter((elem: any) => {
                return elem.Name === key;
            })[0];
        }

        let branch: ITreeAPC_branch = {
            name: obj.name,
            type: 'folder',
            children: [],
            iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj.icon,
            pointer: true,
            clickCallBack: () => {
                obj.id && this.getConf(branch, obj.id);
            }
        };
        for (let key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                if (!isEmpty(obj[key])) {
                    if (this.findType(type, key).ReturnTypes[0].indexOf('System.Collections.Generic.Dictionary') > -1) {
                        for (let dKey in obj[key]) {
                            if (obj[key][dKey].id !== undefined) {
                                let mBranch: ITreeAPC_branch = {
                                    name: obj[key][dKey].name,
                                    type: 'folder',
                                    children: [],
                                    iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj[key][dKey].icon,
                                    pointer: true,
                                    clickCallBack: () => {
                                        obj[key][dKey].id && this.getConf(mBranch, obj[key][dKey].id);
                                    }
                                };
                                if (branch.children !== undefined) {
                                    branch.children.push(mBranch);
                                }
                            }
                        }
                    } else {
                        let mBranch: ITreeAPC_branch = {
                            name: obj[key].name,
                            type: 'folder',
                            children: [],
                            iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj[key].icon,
                            pointer: true,
                            clickCallBack: () => {
                                obj[key].id && this.getConf(mBranch, obj[key].id);
                            }
                        };
                        if (branch.children !== undefined) {
                            branch.children.push(mBranch);
                        }
                    }
                }
            }
        }
        return branch;
    };
    private genTree(data: any, type: any) {
        let tree = this.updateConf(data, type);
        this.setState({
            tree: [tree]
        });
    }

    private genTableForFunc = () => {
        if (this.state.selectedData.ClassName !== undefined) {
            let selectedClass = this.classNameArr.get(this.state.selectedData.ClassName);
            let arr: JSX.Element[] = [];

            console.dir(selectedClass);

            selectedClass.forEach((elem: any, key: number) => {
                if (elem.StructureType === 1) {
                    arr.push(
                        <div
                            style={{
                                background: elem.Name === this.state.selectedNameFunc ? '#ccc' : '',
                                fontSize: '1em',
                                color: '#686868'
                            }}
                            key={elem.Name}
                            onClick={() => {
                                this.setState({ selectedNameFunc: elem.Name });
                            }}>
                            {elem.Name}
                        </div>
                    );
                }
            });

            return arr;
        }
        return null;
    };

    render() {
        return (
            <React.Fragment>
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                    onClick={() => this.props.closeCB && this.props.closeCB()}>
                    <div
                        style={{
                            background: '#fff',
                            padding: '1em',
                            width: '70em',
                            height: '40em',
                            boxShadow: 'rgb(0 0 0 / 5%) 4px 4px 4px',
                            border: '1px solid #ddd'
                        }}
                        onClick={(e) => e.stopPropagation()}>
                        <div style={{ display: 'flex', height: 'calc(100% - 3em)' }}>
                            <div style={{ width: '50%', overflow: 'auto' }}>
                                <TreeAPC inpArr={this.state.tree!} />
                            </div>
                            <div style={{ width: '50%' }}>{this.genTableForFunc()}</div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <Button
                                text={'Сохранить'}
                                onClick={() => {
                                    this.props.saveCB &&
                                        this.props.saveCB(
                                            this.state.selectedData.path,
                                            this.state.selectedData.ClassName,
                                            this.state.selectedNameFunc
                                        );
                                }}
                            />
                            <Button
                                text={'Отмена'}
                                onClick={() => {
                                    this.props.closeCB && this.props.closeCB();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default WindowSettingRefMethod;
